import Rails from '@rails/ujs';

import { Controller } from 'stimulus';

export default class extends Controller {
  initialize() {
    this.submitTimeout = null;
  }

  submit() {
    clearTimeout(this.submitTimeout);
    this.submitTimeout = setTimeout(() => {
      Rails.fire(this.element, 'submit');
    }, 400);
  }
}
